export var buildEnv = {
    buildMode: 'release',
    datacenter: 'us',
    sdkVersion: '2.8.1',
};
//# sourceMappingURL=buildEnv.js.map